module.exports = __webpack_public_path__ + "static/img/cont44_07.2745d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_07.jpg
// module id = YvyI
// module chunks = 0